import { createFileRoute } from '@tanstack/react-router';
import { DocumentsPage } from '@/modules/documents/documents-page';

export const Route = createFileRoute('/_auth/documents-v2')({ component: DocumentsPage });
